import { createFileRoute } from '@tanstack/react-router'
import { Flex, Form } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FormSection } from '../components/form-section'
import { CampaignBasicsSection } from '../campaign/components/settings/campaign-basics-section'
import { CampaignNotificationsSection } from '../campaign/components/settings/campaign-notifications-section'
import { CampaignCustomAttributesSection } from '../campaign/components/settings/campaign-custom-attributes-section'

export const Route = createFileRoute('/_auth/_main/campaigns/$campaignId/settings/')({
    component: CampaignSettingsGeneral,
})

function CampaignSettingsGeneral() {
    const { t } = useTranslation()

    const form = Form.useFormInstance()
    const attributeRows = Form.useWatch('customAttributeRows', form)

    return (
        <Flex
            vertical
            gap="large"
        >
            <FormSection title={t('Details')}>
                <CampaignBasicsSection />
            </FormSection>

            <FormSection
                id="notifications"
                title={t('Notifications')}
            >
                <CampaignNotificationsSection />
            </FormSection>

            <FormSection
                id="custom-attributes"
                title={t('Custom attributes')}
                description={t('Attach your own key-value data to campaigns for integrations and exports.')}
            >
                <CampaignCustomAttributesSection attributeRows={attributeRows} />
            </FormSection>
        </Flex>
    )
}
